import loadable from "@loadable/component";
import { FC, Suspense } from "react";
import { useForm } from "react-hook-form";
import Spinner from "../../components/Reusable/Spinner";
import { ICreateTagsData } from "../../components/Tags/CreateTag";
import APIS from "../../constant/Endpoint";
import usePostFormData from "../../customHooks/usePostFormData";
import { queryClient } from "../../root.component";
import { ITagSchema } from "../../utils/validationSchema";

const CreateTagComponent = loadable(
  () => import("../../components/Tags/CreateTag") as unknown as Promise<FC>
);

export const CreateTag = () => {
  const { mutateAsync, isPostLoading } = usePostFormData<ICreateTagsData>({
    queryKey: ["create-tag"],
    navigateURL: "/blog/tag",
  });

  const handleCreate = async (data: ITagSchema, setError: any) => {
    const file = data.preview_image as File;
    delete data.preview_image;
    const url = `${APIS.BLOG_TAG}`;
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      switch (typeof data[key]) {
        case "string":
        case "number":
        case "boolean":
          formData.append(key, data[key]);
          break;
        default:
          formData.append(key, JSON.stringify(data[key]));
      }
    });
    if (file instanceof File) formData.append("preview_image", file);
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status === 200) {
        queryClient.refetchQueries();
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <Suspense fallback={<Spinner />}>
      <CreateTagComponent
        //@ts-ignore
        handleCreate={handleCreate}
        isLoading={isPostLoading}
      />
    </Suspense>
  );
};
